import { render, staticRenderFns } from "./PreparedMessages.vue?vue&type=template&id=0ef942ae&scoped=true&"
import script from "./PreparedMessages.vue?vue&type=script&lang=js&"
export * from "./PreparedMessages.vue?vue&type=script&lang=js&"
import style0 from "./PreparedMessages.vue?vue&type=style&index=0&id=0ef942ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef942ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VIcon,VTooltip})
